/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable array-callback-return */
import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components/macro";
import * as Yup from "yup";
import ClearIcon from "@mui/icons-material/Clear";
import { ZoomIn, ZoomOut, RestartAlt, VisibilityOff, Visibility } from "@mui/icons-material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ApMachine from "./ApMachine";

import {
  TextField,
  Button,
  Snackbar,
  Alert,
  Paper,
  Typography,
  FormControl,
  Box,
  Grid,
  Card,
  CardContent,
  Modal,
  IconButton,
  FormControlLabel,
  Checkbox,
  Breadcrumbs as MuiBreadcrumbs,
  Link,
  Autocomplete,
  Avatar,
  CircularProgress,
  InputAdornment,
} from "@mui/material";
import { spacing } from "@mui/system";

import { NavLink, useNavigate, useParams } from "react-router-dom";
import { Formik } from "formik";
import DocumentUpload from "../components/DocumentUpload";
import axios from "../../CustomAxios";
import { connect } from "react-redux";
import Loading from "../components/Loading";

const BigAvatar = styled(Avatar)`
  width: 92px;
  height: 92px;
  text-align: center;
  margin: 0 auto ${(props) => props.theme.spacing(5)};
`;

let states = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu and Kashmir",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttarakhand",
  "Uttar Pradesh",
  "West Bengal",
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli",
  "Daman and Diu",
  "Delhi",
  "Lakshadweep",
  "Puducherry",
];

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

function Update({ details, id, urls, up, setUp, setUrls, auths, machineList, page, setPage, limit, setLimit }) {
  const [is_deleted, setIsDeleted] = useState(details.is_deleted);
  const [success, setSuccess] = useState(false);
  const [err, setErr] = useState("");
  const snackRef = useRef(null);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const [state, setState] = useState({
    op: false,
    vertical: "top",
    horizontal: "center",
  });
  const [loader, setLoader] = useState(false);
  const { vertical, horizontal, op } = state;
  const handleClick = (newState) => () => {
    setState({ op: true, ...newState });
  };
  const handleCloseSnack = () => {
    setState({ ...state, op: false });
  };
  const handleClose = () => setOpen(false);
  const [del, setDelete] = useState(false);
  const [openAddDoc, setOpenAdddoc] = useState(false);
  const [u, setU] = useState();
  const [profile, setProfile] = useState();
  const [type, setType] = useState();
  const [signatureFile, setSignatureFile] = useState(null);

  const handleOpen = (url, type) => {
    setU(url);
    setType(type);
    setOpen(true);
    setModalImgHeight(70);
  };
  const [modalImgHeight, setModalImgHeight] = useState(70);
  const handleDownDoc = () => {
    setOpenAdddoc(false);
    setImages({});
    setDocuments({});
  };
  const [open, setOpen] = useState(false);
  const [documents, setDocuments] = useState({});
  const [images, setImages] = useState({});
  const [imgValue, setImgVal] = useState(null);
  const [profileLoader, setProfileLoader] = useState(false);
  const [documentLoader, setDocumentLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [udyamRegNumber, setUdyamRegNumber] = useState(details?.udyam_registration_number || "");
  const [signaturePreview, setSignaturePreview] = useState(null);

  const inputFile = useRef(null);
  const onButtonClick = () => {
    inputFile.current.click();
  };
  const handleOpenDoc = () => {
    setOpenAdddoc(true);
  };

  useEffect(() => {
    let pf = urls.find((item) => item.name === "profile_picture");
    setProfile(pf !== undefined ? pf.url : "");
  }, [urls]);

  const formData = new FormData();

  const deleteDocument = async (key, isSignature = false) => {
    if (isSignature) {
      setErr("Company signature cannot be deleted. Upload a new one to replace it.");
      snackRef.current.click();
      return;
    }
    try {
      setDelete(false);
      setDocumentLoader(true);
      const authData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
      };
      const { data } = await axios.delete(
        `/api/v1/${authData?.type}/media/ap_company/${id}/${key}`,
        config
      );
      if (data.success) {
        setSuccess(true);
        setErr("");
        setMessage("Document Deleted successfully");
        snackRef.current.click();
        setUrls([]);
        setDocumentLoader(false);
        setUp(up + 1);
      }
    } catch (e) {
      setErr(e.response.data.error);
      snackRef.current.click();
      setLoader(false);
      console.log(e);
      setDocumentLoader(false);
    }
  };

  const addDocuments = async () => {
    try {
      setDocumentLoader(true);
      let br = 0;
      Object.values(images).map((doc, i) => {
        if (!documents[i]) {
          setErr("Document Name field cannot be empty");
          setSuccess(false);
          snackRef.current.click();
          br = 1;
          return;
        }
      });
      if (!br) {
        handleDownDoc();
        const authData = JSON.parse(localStorage.getItem("AuthData"));
        Object.values(images).map((image, i) => {
          formData.set(`document_${i + 1}_file`, image);
        });
        Object.values(documents).map((doc, i) => {
          formData.set(`document_${i + 1}_name`, doc);
        });
        const config = {
          headers: {
            Authorization: "Bearer " + authData.access_token,
          },
        };
        const { data } = await axios.post(
          `/api/v1/${authData?.type}/media/ap_company/${id}`,
          formData,
          config
        );
        if (data.success) {
          setSuccess(true);
          setErr("");
          setMessage("Documents Added Successfully");
          snackRef.current.click();
          setUrls([]);
          setUp(up + 1);
          setDocumentLoader(false);
        }
      }
    } catch (e) {
      setErr(e.response.data.error);
      snackRef.current.click();
      setLoader(false);
      console.log(e);
      setDocumentLoader(false);
    }
  };

  const handleProfileChange = async () => {
    try {
      setProfileLoader(true);
      let formDt = new FormData();
      formDt.set("profile_picture", imgValue);
      const authData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
      };

      const { data } = await axios.post(
        `/api/v1/${authData?.type}/media/ap_company/${id}`,
        formDt,
        config
      );

      if (data.success) {
        setSuccess(true);
        setErr("");
        setMessage("Profile picture updated successfully");
        snackRef.current.click();
        setUrls([]);
        setUp(up + 1);
        setProfileLoader(false);
      }
    } catch (error) {
      setErr(error.response.data.error);
      snackRef.current.click();
      setLoader(false);
      console.log(error);
      setProfileLoader(false);
    }
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const submit = async (values) => {
    setLoader(true);
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + authData.access_token,
      },
    };

    let requestData;
    let isFormData = false;

    if (signatureFile) {
      isFormData = true;
      const formData = new FormData();
      formData.append("company_code", values.company_code);
      formData.append("email_address", values.email_address);
      formData.append("name", values.name);
      formData.append("phone_number", values.phone_number);
      formData.append("landline_number", values.landline_number);
      formData.append("address_line_one", values.address_one);
      formData.append("address_line_two", values.address_two);
      formData.append("pincode", values.pincode);
      formData.append("state", values.state);
      formData.append("city", values.city);
      formData.append("gst_number", values.gst_number);
      formData.append("pan_number", values.pan_number);
      formData.append("bank_details", values.bank_details);
      formData.append("is_deleted", Boolean(is_deleted));
      formData.append("is_irn_allowed", values.is_irn_allowed);
      formData.append("irn_username", values.irn_username);
      formData.append("irn_password", values.irn_password);
      formData.append("udyam_registration_number", udyamRegNumber);
      formData.append("company_sign", signatureFile);
      requestData = formData;
      config.headers["Content-Type"] = "multipart/form-data";
    } else {
      requestData = {
        company_code: values.company_code,
        email_address: values.email_address,
        name: values.name,
        phone_number: values.phone_number,
        landline_number: values.landline_number,
        address_line_one: values.address_one,
        address_line_two: values.address_two,
        pincode: values.pincode,
        state: values.state,
        city: values.city,
        gst_number: values.gst_number,
        pan_number: values.pan_number,
        bank_details: values.bank_details,
        is_deleted: Boolean(is_deleted),
        is_irn_allowed: values.is_irn_allowed,
        irn_username: values.irn_username,
        irn_password: values.irn_password,
        udyam_registration_number: udyamRegNumber,
      };
    }

    try {
      const { data } = await axios.put(
        `/api/v1/${authData.type}/ap_company/${id}`,
        requestData,
        config
      );
      if (data.success) {
        setErr("");
        setSuccess(true);
        setMessage("AP Company Details Updated Successfully");
        snackRef.current.click();
        navigate("/dashboard/company/ap-companies", {
          state: {
            message: "AP Company Details Updated Successfully",
            success: true,
          },
        });
      }
    } catch (e) {
      setErr(e.response?.data?.error || "Update failed");
      snackRef.current.click();
    } finally {
      setLoader(false);
    }
  };

  const Mob = styled.div`
    ${(props) => props.theme.breakpoints.down("md")} {
      display: none;
    }
  `;

  return (
    <Formik
      initialValues={{
        company_code: details?.company_code,
        email_address: details?.email_address,
        name: details?.name,
        phone_number: details?.phone_number,
        landline_number: details?.landline_number,
        address_one: details?.address_line_one,
        address_two: details?.address_line_two,
        pincode: details?.pincode,
        state: details?.state,
        city: details?.city,
        gst_number: details?.gst_number,
        pan_number: details?.pan_number,
        bank_details: details?.bank_details,
        submit: false,
        is_irn_allowed: details.is_irn_allowed ? details.is_irn_allowed : false,
        irn_username: details.irn_username ? details.irn_username : "",
        irn_password: details.irn_password ? details.irn_password : "",
      }}
      validationSchema={Yup.object().shape({
        email_address: Yup.string()
          .email("Must be a valid email")
          .max(255)
          .required("Email is required"),
        name: Yup.string().max(255).required("name is required"),
        address_one: Yup.string()
          .max(1000)
          .required("Address Line 1 is required"),
        address_two: Yup.string()
          .max(1000)
          .required("Address Line 2 is required"),
        pincode: Yup.string()
          .required("Pincode is required")
          .length(6, "Pincode should have 6 digits"),
        state: Yup.string().required("State is Required"),
        city: Yup.string().required("City is required"),
        gst_number: Yup.string()
          .length(15, "Should have 15 character")
          .required("GST number is required"),
        pan_number: Yup.string()
          .required("PAN Number is Required")
          .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invalid PAN Number"),
        phone_number: Yup.string()
          .required("Phone Number is required")
          .matches(/^(((\+){1}91){1})?[6-9]{1}[0-9]{9}$/, {
            message: "Invalid Indian number",
            excludeEmptyString: false,
          }),
        bank_details: Yup.string().required("Bank Details are required"),
        is_irn_allowed: Yup.boolean(),
        irn_username: Yup.string().when('is_irn_allowed', {
          is: true,
          then: Yup.string().trim().min(1, "Enter Valid Username")
            .required('IRN Username is required')
        }),
        irn_password: Yup.string().when('is_irn_allowed', {
          is: true,
          then: Yup.string().trim().min(1, "Enter Valid Password")
            .required('IRN Password is required')
        })
      })}
      onSubmit={async (
        values,
        { setErrors, setStatus, setSubmitting, resetForm }
      ) => {
        try {
          submit(values);
        } catch (error) {
          const message = error.message || "Something went wrong";

          setStatus({ success: false });
          setErrors({ submit: message });
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        touched,
        values,
      }) => (
        <form noValidate onSubmit={handleSubmit}>
          <Button
            ref={snackRef}
            style={{ display: "none" }}
            onClick={handleClick({ vertical: "top", horizontal: "center" })}
          >
            Click
          </Button>
          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            open={op}
            onClose={handleCloseSnack}
            key={vertical + horizontal}
          >
            {err ? (
              <Alert mt={2} mb={4} severity="error">
                {err}
              </Alert>
            ) : success ? (
              <Alert mt={2} mb={4} severity="success">
                {message}
              </Alert>
            ) : null}
          </Snackbar>
          {errors.submit && (
            <Alert mt={2} mb={1} severity="warning">
              {errors.submit}
            </Alert>
          )}
          {!loader ? (
            <>
              <Card mb={6}>
                <CardContent>
                  <Paper elevation={3} style={{ padding: "2%" }}>
                    <Grid container spacing={5}>
                      <Grid item xs={12} lg={12} md={12}>
                        <Typography variant="h6" gutterBottom>
                          Update AP Company
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={12} lg={12}>
                        <BigAvatar
                          onClick={onButtonClick}
                          style={{ cursor: "pointer" }}
                          src={profile}
                        />
                        <input
                          type="file"
                          id="file"
                          ref={inputFile}
                          accept=".png, .jpg, .jpeg"
                          onChange={(e) => {
                            setProfile(URL.createObjectURL(e.target.files[0]));
                            setImgVal(e.target.files[0]);
                          }}
                          style={{ display: "none" }}
                        />
                        <Typography
                          component="h1"
                          variant="h4"
                          align="center"
                          gutterBottom
                        >
                          <Button
                            variant="outlined"
                            onClick={handleProfileChange}
                            disabled={profileLoader}
                          >
                            {profileLoader ? (
                              <>
                                Updating Profile Picture{" "}
                                <CircularProgress
                                  size={20}
                                  style={{ marginLeft: "8px" }}
                                />
                              </>
                            ) : (
                              "Update Profile picture"
                            )}
                          </Button>
                        </Typography>
                      </Grid>
                      <Grid item xs={12} lg={12} md={12}>
                        <TextField
                          fullWidth
                          type="text"
                          name="company_code"
                          label="Company Code"
                          value={values.company_code}
                          inputProps={{ readOnly: true }}
                        />
                      </Grid>
                      <Grid item xs={12} lg={12} md={12}>
                        <TextField
                          fullWidth
                          type="text"
                          name="name"
                          label="name"
                          value={values.name}
                          error={Boolean(touched.name && errors.name)}
                          helperText={touched.name && errors.name}
                          onBlur={handleBlur}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={12} lg={12} md={12}>
                        <TextField
                          type="email"
                          name="email_address"
                          label="Email address"
                          value={values.email_address}
                          error={Boolean(
                            touched.email_address && errors.email_address
                          )}
                          fullWidth
                          helperText={
                            touched.email_address && errors.email_address
                          }
                          onBlur={handleBlur}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={12} lg={12} md={12}>
                        <TextField
                          type="text"
                          name="phone_number"
                          label="Phone Number"
                          value={values.phone_number}
                          error={Boolean(
                            touched.phone_number && errors.phone_number
                          )}
                          fullWidth
                          helperText={
                            touched.phone_number && errors.phone_number
                          }
                          onBlur={handleBlur}
                          onChange={handleChange}
                        />
                      </Grid>

                      <Grid item xs={12} lg={12} md={12}>
                        <TextField
                          type="text"
                          name="landline_number"
                          label="Landline Number"
                          value={values.landline_number}
                          fullWidth
                          onBlur={handleBlur}
                          onChange={handleChange}
                        />
                      </Grid>

                      <Grid item xs={12} lg={12} md={12}>
                        <TextField
                          type="text"
                          name="gst_number"
                          label="GST Number"
                          value={values.gst_number}
                          error={Boolean(
                            touched.gst_number && errors.gst_number
                          )}
                          fullWidth
                          helperText={touched.gst_number && errors.gst_number}
                          onBlur={handleBlur}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={12} lg={12} md={12}>
                        <TextField
                          type="text"
                          name="pan_number"
                          label="PAN Number"
                          value={values.pan_number}
                          error={Boolean(
                            touched.pan_number && errors.pan_number
                          )}
                          fullWidth
                          helperText={touched.pan_number && errors.pan_number}
                          onBlur={handleBlur}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={12} lg={12} md={12}>
                        <TextField
                          type="text"
                          name="bank_details"
                          label="Bank Details"
                          value={values.bank_details}
                          error={Boolean(
                            touched.bank_details && errors.bank_details
                          )}
                          fullWidth
                          helperText={
                            touched.bank_details && errors.bank_details
                          }
                          onBlur={handleBlur}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={12} lg={12} md={12}>
                        <TextField
                          fullWidth
                          name="udyam_registration_number"
                          label="Udyam Registration Number"
                          value={udyamRegNumber}
                          onChange={(e) => setUdyamRegNumber(e.target.value)}
                        />
                      </Grid>

                      <Grid item xs={12} lg={12} md={12}>
                        <TextField
                          fullWidth
                          name="address_one"
                          error={Boolean(
                            touched.address_one && errors.address_one
                          )}
                          value={values.address_one}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          label={"Address Line 1"}
                          helperText={touched.address_one && errors.address_one}
                        />
                      </Grid>
                      <Grid item xs={12} lg={12} md={12}>
                        <TextField
                          fullWidth
                          name="address_two"
                          error={Boolean(
                            touched.address_two && errors.address_two
                          )}
                          value={values.address_two}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          label={"Address Line 2"}
                          helperText={touched.address_two && errors.address_two}
                        />
                      </Grid>
                      <Grid item xs={12} lg={12} md={12}>
                        <TextField
                          fullWidth
                          name="pincode"
                          error={Boolean(touched.pincode && errors.pincode)}
                          value={values.pincode}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          label={"Pincode"}
                          helperText={touched.pincode && errors.pincode}
                        />
                      </Grid>
                      <Grid item xs={12} md={12} lg={12}>
                        <FormControl
                          fullWidth
                          error={Boolean(touched.state && errors.state)}
                        >
                          <Autocomplete
                            id="combo-box-demo"
                            options={states}
                            value={values?.state || ""}
                            onChange={(event, newValue) => {
                              setFieldValue("state", newValue || "");
                            }}
                            onBlur={handleBlur}
                            getOptionLabel={(option) => option}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                error={Boolean(touched.state && errors.state)}
                                helperText={touched.state && errors.state}
                                label="Select State"
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} lg={12} md={12}>
                        <TextField
                          fullWidth
                          name="city"
                          error={Boolean(touched.city && errors.city)}
                          value={values.city}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          label={"City"}
                          helperText={touched.city && errors.city}
                        />
                      </Grid>
                      <Grid item xs={12} lg={12} md={12}>
                        <Typography variant="subtitle1">Company Signature</Typography>
                        <Button variant="outlined" component="label">
                          Upload Signature
                          <input
                            type="file"
                            hidden
                            accept="image/png, image/jpeg, image/jpg"
                            onChange={(e) => {
                              const file = e.target.files[0];
                              if (file) {
                                if (!file.type.startsWith('image/')) {
                                  setErr('Only image files are allowed for company signature');
                                  snackRef.current.click();
                                  e.target.value = null;
                                  return;
                                }
                                if (signaturePreview) {
                                  URL.revokeObjectURL(signaturePreview);
                                }
                                const previewUrl = URL.createObjectURL(file);
                                setSignaturePreview(previewUrl);
                                setSignatureFile(file);
                              }
                            }}
                          />
                        </Button>
                        {signaturePreview && (
                          <Box mt={1}>
                            <Typography variant="caption" display="block" gutterBottom>
                              Signature Preview:
                            </Typography>
                            <Box
                              component="img"
                              src={signaturePreview}
                              alt="Signature preview"
                              sx={{
                                maxWidth: '200px',
                                maxHeight: '100px',
                                border: '1px solid #ccc',
                                borderRadius: 1,
                                objectFit: 'contain',
                              }}
                            />
                          </Box>
                        )}
                      </Grid>
                      <Grid item xs={12} lg={3} md={3}>
                        <FormControl
                          fullWidth
                          component="fieldset"
                          variant="standard"
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                                name="is_irn_allowed"
                                checked={values.is_irn_allowed}
                                onChange={handleChange}
                              />
                            }
                            label={"Enable IRN"}
                          />
                        </FormControl>
                      </Grid>
                      {values.is_irn_allowed ? (
                        <>
                          <Grid item xs={12} lg={12} md={12}>
                            <TextField
                              fullWidth
                              name="irn_username"
                              error={Boolean(touched.irn_username && errors.irn_username)}
                              value={values.irn_username}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              label={"IRN Username"}
                              helperText={touched.irn_username && errors.irn_username}
                            />
                          </Grid>

                          <Grid item xs={12} lg={12} md={12}>
                            <TextField
                              fullWidth
                              name="irn_password"
                              type={showPassword ? "text" : "password"}
                              error={Boolean(touched.irn_password && errors.irn_password)}
                              value={values.irn_password}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              label={"IRN Password"}
                              helperText={touched.irn_password && errors.irn_password}
                              InputProps={{
                                endAdornment: <InputAdornment position="end">
                                  <IconButton
                                    onClick={() => setShowPassword(!showPassword)}
                                    edge="end"
                                  >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                  </IconButton>
                                </InputAdornment>
                              }}
                            />
                          </Grid>
                        </>
                      ) : ""}
                      <Grid item xs={12} lg={3} md={3}>
                        <FormControl
                          fullWidth
                          component="fieldset"
                          variant="standard"
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={is_deleted}
                                onChange={(e) => setIsDeleted(e.target.checked)}
                                inputProps={{ "aria-label": "controlled" }}
                              />
                            }
                            label={"Is Deleted"}
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Paper>
                </CardContent>
              </Card>

              <Modal open={open} onClose={handleClose}>
                <Card sx={style}>
                  <CardContent>
                    <Paper>
                      <Grid container justifyContent="center" spacing={5}>
                        <Grid
                          item
                          xs={12}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <IconButton
                            onClick={() =>
                              setModalImgHeight(modalImgHeight + 5)
                            }
                          >
                            <ZoomIn />
                          </IconButton>
                          <IconButton
                            onClick={() =>
                              setModalImgHeight(modalImgHeight - 5)
                            }
                          >
                            <ZoomOut />
                          </IconButton>
                          <IconButton onClick={() => setModalImgHeight(70)}>
                            <RestartAlt />
                          </IconButton>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            maxHeight: "72.5vh",
                            overflowY: "scroll",
                          }}
                        >
                          {type !== "pdf" ? (
                            <Box
                              component={"img"}
                              src={u}
                              height={modalImgHeight.toString() + "vh"}
                              width="auto"
                            />
                          ) : (
                            <iframe
                              height={(modalImgHeight + 420).toString() + "vh"}
                              width={(modalImgHeight + 420).toString() + "vh"}
                              src={u}
                            />
                          )}
                        </Grid>
                      </Grid>
                    </Paper>
                  </CardContent>
                </Card>
              </Modal>
              <Modal
                open={openAddDoc}
                onClose={handleDownDoc}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style}>
                  <Typography
                    id="modal-modal-title"
                    variant="h6"
                    align="center"
                    color="primary"
                  >
                    Add Documents
                  </Typography>
                  <DocumentUpload
                    documents={documents}
                    setDocuments={setDocuments}
                    images={images}
                    setImages={setImages}
                  />
                  <Button onClick={addDocuments}>Add</Button>
                </Box>
              </Modal>
              <Card mb={6}>
                <CardContent>
                  <Paper elevation={3} style={{ padding: "2%" }}>
                    <Grid container spacing={5}>
                      <Grid item xs={12} lg={12} md={12}>
                        <Typography variant="h4" gutterBottom>
                          Document Details
                        </Typography>
                      </Grid>
                      {!urls.filter(url => url.name !== "profile_picture").length ? (
                        <Grid item xs={12} md={12} lg={12}>
                          <Typography variant="h6" color="primary" gutterBottom>
                            No Documents Added
                          </Typography>
                        </Grid>
                      ) : null}
                      {documentLoader ? (
                        "Loading Documents...."
                      ) : (
                        <>
                          {urls &&
                            urls.map((url) => {
                              if (url?.name === "profile_picture") return null;

                              const isSignature = url.name === "Company Signature";
                              return (
                                <Paper
                                  key={url.key || url.url}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "100%",
                                    marginTop: "10px",
                                  }}
                                  mt={3}
                                >
                                  <Box
                                    component="img"
                                    width="90px"
                                    height="80px"
                                    onClick={() =>
                                      handleOpen(url?.url, url?.type)
                                    }
                                    src={
                                      url?.type === "pdf"
                                        ? "/static/img/images/pdf.png"
                                        : url?.url
                                    }
                                    style={{ cursor: "pointer" }}
                                  />
                                  <TextField
                                    fullWidth
                                    margin="dense"
                                    m={2}
                                    style={{ marginLeft: 32, width: "100%" }}
                                    inputProps={{ readOnly: true }}
                                    id="standard-required"
                                    label="Document Name"
                                    value={url?.name || ""}
                                  />
                                  {!del ? (
                                    <Mob>
                                      <Grid item>
                                        <a
                                          href={url?.url}
                                          style={{
                                            color: "inherit",
                                            textDecoration: "inherit",
                                          }}
                                          download={`${url?.name}.${url?.type}`}
                                        >
                                          <FileDownloadIcon
                                            style={{
                                              marginLeft: 32,
                                              cursor: "pointer",
                                            }}
                                          />
                                        </a>
                                      </Grid>
                                    </Mob>
                                  ) : (
                                    <Grid item>
                                      {isSignature ? (
                                        <ClearIcon
                                          style={{
                                            marginLeft: 32,
                                            cursor: "not-allowed",
                                            opacity: 0.5
                                          }}
                                          onClick={() => deleteDocument(url?.key, true)}
                                        />
                                      ) : (
                                        <ClearIcon
                                          onClick={() =>
                                            deleteDocument(url?.key)
                                          }
                                          style={{
                                            marginLeft: 32,
                                            cursor: "pointer",
                                          }}
                                        />
                                      )}
                                    </Grid>
                                  )}
                                </Paper>
                              );
                            })}
                        </>
                      )}
                      <br />
                      {!del ? (
                        <Grid item xs={12} md={12} lg={12}>
                          <Button
                            onClick={handleOpenDoc}
                            disabled={documentLoader}
                          >
                            Add Document
                          </Button>
                          <Button
                            onClick={() => setDelete(true)}
                            style={{ color: "red" }}
                            disabled={documentLoader}
                          >
                            Delete Document
                          </Button>
                        </Grid>
                      ) : (
                        <Grid item xs={12} md={12} lg={12}>
                          <Button onClick={() => setDelete(false)}>
                            Cancel
                          </Button>
                        </Grid>
                      )}
                    </Grid>
                  </Paper>
                </CardContent>
              </Card>

              <Grid item xs={12} lg={12} md={12}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={isSubmitting}
                >
                  Update
                </Button>
              </Grid>
            </>
          ) : (
            <Loading />
          )}
        </form>
      )}
    </Formik>
  );
}

const getDetails = async (setDetails, setLoader, id, setUrls, setErr) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + authData.access_token,
      },
    };

    const { data } = await axios.get(
      `/api/v1/${authData?.type}/ap_company/${id}`,
      config
    );
    if (data.success) {
      setDetails(data.data);
      setLinks(data.data.documents, data.data.company_sign, setUrls, setLoader);
    }
  } catch (e) {
    setLoader(false);
    setErr(e.response.data.error);
    console.log(e);
  }
};

const setLinks = (documents, companySign, setUrls, setLoader) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    let urls = [];

    // Add regular documents
    documents.forEach((doc) => {
      const type = doc?.document_storage_info?.key?.split(".")[1];
      urls.push({
        url: `/api/v1/${authData?.type}/media/${doc.document_storage_info.key}`,
        name: doc.document_title,
        type: type,
        key: doc?.document_storage_info?.key,
      });
    });

    // Add company sign if present
    if (companySign?.document_storage_info?.key) {
      const type = companySign.document_storage_info.key.split(".")[1];
      urls.push({
        url: `/api/v1/${authData?.type}/media/${companySign.document_storage_info.key}`,
        name: "Company Signature",
        type: type,
        key: companySign.document_storage_info.key,
      });
    }

    sendRequests(urls, setUrls, setLoader);
  } catch (e) {
    console.log(e);
  }
};

const sendRequests = async (urls, setUrls, setLoader) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    let num = urls.length;
    if (num === 0) {
      setLoader(false);
    }
    let n = 0;
    let allUrls = [];
    let promiseArr = urls.map((l) => {
      let PROD_URL = "";
      if (process.env.NODE_ENV === "development") {
        PROD_URL = process.env.REACT_APP_BACKEND_DEV_API_URL;
      } else {
        PROD_URL = process.env.REACT_APP_BACKEND_PRODUCTION_API_URL;
      }

      fetch(PROD_URL + l.url, {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
        method: "GET",
      })
        .then(async (resp) => {
          return resp.arrayBuffer();
        })
        .then(async (res) => {
          n++;
          if (l.type === "pdf") {
            const myFile = new Blob([res], { type: "application/pdf" });
            const url = URL.createObjectURL(myFile);
            allUrls.push({
              url: url,
              name: l.name,
              type: l.type,
              key: l.key,
              stage: l.stage,
            });
          } else {
            const myFile = new Blob([res], { type: "image/png" });
            const url = URL.createObjectURL(myFile);
            allUrls.push({
              url: url,
              name: l.name,
              type: l.type,
              key: l.key,
              stage: l.stage,
            });
          }
          if (n === num) {
            setUrls(allUrls);
            setLoader(false);
          }
        });
    });
  } catch (e) {
    console.log(e);
  }
};

function UpdateApCompany({ auths }) {
  const [details, setDetails] = useState(null);
  const [loader, setLoader] = useState(true);
  const { company_id } = useParams();
  const [urls, setUrls] = useState([]);
  const [up, setUp] = useState(0);
  const [err, setErr] = useState(null);
  const [success, setSuccess] = useState(null);
  const [machineList, setMachineList] = useState([]);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(5);
  const [sorting_field, setSortingField] = useState("created_at");
  const [sorting_order, setSortingOrder] = useState("desc");
  const [is_deleted, setIsDeleted] = useState(false);
  const [total_results, setTotalResults] = useState(0);
  const authData = JSON.parse(localStorage.getItem("AuthData"));
  const [metadata, setMetadata] = useState({});
  const snackRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [snackState, setSnackState] = useState({
    op: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, op } = snackState;
  const handleClick = (newState) => () => {
    setSnackState({ op: true, ...newState });
  };
  const handleClose = () => {
    setSnackState({ ...snackState, op: false });
  };

  const fetchMachineList = async () => {
    try {
      setLoading(true);
      const authData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
      };
      const { data } = await axios.get(
        `/api/v1/${authData?.type}/machine/specific/${company_id}?page=${page + 1}&limit=${limit}`,
        config
      );
      if (data.success) {
        setMachineList(data.data);
        setTotalResults(data.metadata.total_results);
        setMetadata(data.metadata);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMachineList();
  }, [page, limit]);

  useEffect(() => {
    fetchMachineList();
    getDetails(setDetails, setLoader, company_id, setUrls, setErr);
  }, []);

  useEffect(() => {
    if (up) {
      getDetails(setDetails, setLoader, company_id, setUrls, setErr);
    }
  }, [up]);

  useEffect(() => {
    if (err) {
      snackRef.current.click();
    }
  }, [err]);

  if (loader) {
    return (
      <>
        <Button
          ref={snackRef}
          style={{ display: "none" }}
          onClick={handleClick({ vertical: "top", horizontal: "center" })}
        >
          Click
        </Button>
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={op}
          onClose={handleClose}
          key={vertical + horizontal}
        >
          {err ? (
            <Alert mt={2} mb={4} severity="error">
              {err}
            </Alert>
          ) : success ? (
            <Alert mt={2} mb={4} severity="success">
              {success}
            </Alert>
          ) : null}
        </Snackbar>
        <Loading />
      </>
    );
  } else {
    return (
      <React.Fragment>
        <Button
          ref={snackRef}
          style={{ display: "none" }}
          onClick={handleClick({ vertical: "top", horizontal: "center" })}
        >
          Click
        </Button>
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={op}
          onClose={handleClose}
          key={vertical + horizontal}
        >
          {err ? (
            <Alert mt={2} mb={4} severity="error">
              {err}
            </Alert>
          ) : success ? (
            <Alert mt={2} mb={4} severity="success">
              {success}
            </Alert>
          ) : null}
        </Snackbar>

        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              UPDATE AP COMPANY
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Link component={NavLink} to="/dashboard/company/ap-companies">
                AP Companies
              </Link>
              <Typography>Update AP Company</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            {details && (
              <Update
                up={up}
                setUp={setUp}
                urls={urls}
                id={company_id}
                details={details}
                setUrls={setUrls}
                auths={auths}
                machineList={machineList}
                page={page}
                setPage={setPage}
                limit={limit}
                setLimit={setLimit}
                is_deleted={is_deleted}
              />
            )}
          </Grid>
          <Grid item xs={12}>
            {(auths?.user?.role?.permissions?.includes("view_ap_machine_list") || authData?.type === "super_admin") && <ApMachine auths={auths} machineList={machineList} page={page} setPage={setPage} limit={limit} setLimit={setLimit} is_deleted={is_deleted} total_results={total_results} fetchMachineList={fetchMachineList} metadata={metadata} loading={loading} />}
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});

export default connect(mapStateToProps, null)(UpdateApCompany);